var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource-container"},[_c('b-row',{attrs:{"align-v":"start"}},_vm._l((_vm.resources),function(resource){return _c('b-col',{key:resource.id,staticClass:"mb-3",attrs:{"cols":"12","lg":"4","md":"6","sm":"6","xs":"12"}},[_c('ResourceCard',{attrs:{"resource":resource}})],1)}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4158c062","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/ResourcesList.vue
// module id = null
// module chunks = 